export default "__VITE_ASSET__8a9a9b45__"